export default {
  state: {
    user: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload;
    }
  },
  actions: {
    signUserIn ({commit}, payload) {
      commit('setUser', payload);
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    resetPasswordWithEmail ({ commit }, payload) {
      // const { email } = payload
      commit('setLoading', true);
      // Petition a graphql, concatenada con el siguiente then..
      // .then(
      //   () => {
      //     commit('setLoading', false)
      //     console.log('Email Sent')
      //   }
      // )
      // .catch(
      //   error => {
      //     commit('setLoading', false)
      //     commit('setError', error)
      //     console.log(error)
      //   }
      // )
    },
    logout ({commit}) {
      // Petition a graphql, concatenada con el siguiente then..
      commit('setUser', null);
    }
  },
  getters: {
    user (state) {
      return state.user;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user/index.js